const env = "prod";

const Config = {
  prod: {
    apiEndpoint: "https://core.ginastee.com/api",
    wsEndpoint: "wss://api.ginastee.com/app/7d73d67e780a94f36a34t",

    auth: "https://auth.ginastee.com?redirect_uri=https://app.ginastee.com",

    help: "https://help.ginastee.com",

    communityBuilder: "https://ai.ginastee.com/",

    googlePlacesApiKey: "AIzaSyCtACR9J-RKolWt8d3UTKB-wy4q2C7ps14",
  },

  home: {
    //apiEndpoint: "http://localhost:8000/api",
    apiEndpoint: "https://tests.core.ginastee.com/api",
    wsEndpoint: "ws://10.0.0.111:6001/app/ginastee-app-chat",

    auth: "https://auth-test.ginastee.com?redirect_uri=http://localhost:3000",

    help: "https://help.ginastee.com",

    communityBuilder: "https://ai.ginastee.com/",

    googlePlacesApiKey: "AIzaSyCtACR9J-RKolWt8d3UTKB-wy4q2C7ps14",
  },

  apiToken: getToken(),
};

function getToken() {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!token) return false;
    return token;
  } catch (e) {
    return false;
  }
}

export default Config[env];

export const token = Config.apiToken;
export const environment = env;
export const appVersion = "0.1.0";
export const termsUrl = "https://ginastee.com/privacy/";